import { useState, useEffect, useCallback } from 'react';
import { getBooks, createBook, deleteBook, Book } from '../lib/nocodb';

export function useBooks() {
  const [books, setBooks] = useState<Book[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchBooks = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getBooks();
      setBooks(response.list || []);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBooks();
  }, [fetchBooks]);

  const addBook = async (title: string, author: string, coverUrl?: string, publicationYear?: number) => {
    try {
      const bookData: { title: string; author: string; cover_url?: string; publication_year?: number } = { 
        title, 
        author 
      };
      
      if (coverUrl) bookData.cover_url = coverUrl;
      if (publicationYear) bookData.publication_year = publicationYear;
      
      const newBook = await createBook(bookData);
      setBooks((prevBooks) => [...prevBooks, newBook]);
      return newBook;
    } catch (err) {
      setError(err as Error);
      throw err; // Re-throw to be caught in the component
    }
  };

  const removeBook = async (bookId: number) => {
    try {
      await deleteBook(bookId);
      setBooks(prevBooks => prevBooks.filter(book => book.Id !== bookId));
    } catch (err) {
      setError(err as Error);
      throw err;
    }
  };

  return { books, loading, error, refetchBooks: fetchBooks, addBook, removeBook };
}
